import { type FC } from "react";

import { Input } from "@/shared/components/ui/input";

interface ArticleSearchProps {
  value: string;
  onChange: (value: string) => void;
}

export const ArticleSearch: FC<ArticleSearchProps> = ({ value, onChange }) => {
  return (
    <div className="w-full md:max-w-[400px]">
      <Input
        variant="search"
        placeholder="Search articles..."
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
};

export default ArticleSearch;
